/**
 * See: https://github.com/momega/isolate-form
 * Taken from version 1.0.6; added conditional support (isolate-form="false")
 */

import angular from 'angular';

let module = angular.module('recaps.directives.isolateForm', []);

module.directive('isolateForm', [function () {
  return {
    restrict: 'A',
    require: '?form',
    link: function (scope, elm, attrs, ctrl) {
      if (!ctrl) {
        return;
      }
      if (attrs && 'isolateForm' in attrs && (!attrs.isolateForm || attrs.isolateForm === 'false')) {
        console.debug(`isolateForm set to false; not executing`);
        return;
      } else {
        console.debug(`isolateForm executing`);
      }

      // Get the parent of the form
      let parent = elm.parent().controller('form');
      // Remove parent link to the controller
      parent.$removeControl(ctrl);
    }
  };
}]);

export default module;
